import React, { useState, useEffect } from "react";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import ScoreCardList from "../ScoreCardList/ScoreCardList";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { wolStats } from "../../services/WollOfLegends";
import {
    getSession,
    getUserRBAC,
    getWolStatCat,
} from "../../services/LocalStorageService";
import { APIURL, EntityAccess, RBAC_CODE, TableComponentCodes } from "../../config/app-globals.enum";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import ShowMoreOrLess from "../CustomComponents/PraisoTable/ShowMoreOrLess";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function WallofLegends(props) {
    const params = useParams();
    const { t } = useTranslation();
    const [getRBAC_WOL] = React.useState(getUserRBAC(RBAC_CODE.WOL_VIEW, props));
    const [getRBAC_WOL_Show_Limited] = React.useState(
        getUserRBAC(RBAC_CODE.WOL_SHOW_LIMITED_USER_BUTTON_VIEW, props)
    );
    const [wolDataExists, setWolDataExists] = useState(false);
    const [userSession] = useState(getSession());
    const [selectedStatId, setSelectedStatId] = useState(0);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [isApi1Failed, setIsApi1Failed] = React.useState(false);
    const [isApi, setIsApi] = React.useState(false);
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [wolStatCat] = React.useState(getWolStatCat);
    const [wolStatsData, setWolStatsData] = React.useState(null);
    const [wolTableData, setWolTableData] = React.useState();
    const [showLimitedDriver, setShowLimitedDriver] = useState(null);
    const [apiFilterParams, setApiFilterParams] = useState();

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    useEffect(() => {
        setShowLimitedDriver(
            getRBAC_WOL_Show_Limited &&
                getRBAC_WOL_Show_Limited.isAccessible === EntityAccess.ALLOWED
                ? 1
                : 0
        );
    }, [getRBAC_WOL_Show_Limited]);

    useEffect(() => {
        async function getWolStats() {
            setStatusValue(null);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await wolStats(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                if (data.content.length > 0) {
                    const wolStatDataArray = [];
                    for (const stat of wolStatCat) {
                        let statData = data.content.find((item) => item.statId === stat.id);
                        if (statData) {
                            statData = {
                                ...statData,
                                value: statData.statsCount,
                                statCode: stat.code,
                                label: stat.name,
                                color: stat.color,
                                dataLoaded: true,
                            };
                            wolStatDataArray.push(statData);
                        }
                    }
                    setWolStatsData(wolStatDataArray);
                }
            } else {
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
        getWolStats();
    }, [wolStatCat]);

    useEffect(() => {
        // if (apiFilterParams) {
        //   const getWolList = async (apiFilterParams) => {
        //     setStatusValue(null);
        //     setAlertMessage("");
        //     setIsAlertOpen(false);
        //     setIsApi(true);
        //     const data = await wolList(apiFilterParams);
        //     if (
        //       data &&
        //       (data.status.code === 0 ||
        //         data.status.code === 200 ||
        //         data.status.code === 201) &&
        //       data.content
        //     ) {
        //       setIsApi1Failed(false);
        //       setWolDataExists(true);
        //       setWolTableData(data.content);
        //       setIsApi(false);
        //     } else {
        //       setIsApi(false);
        //       setIsApi1Failed(true);
        //       changeApiStatusCodeFunc(data.status);
        //     }
        //   };
        //   getWolList(apiFilterParams);
        // }
    }, [apiFilterParams]);
    // const getWolList = async (filterParams) => {
    //   setStatusValue(null);
    //   setAlertMessage("");
    //   setIsAlertOpen(false);
    //   setIsApi(true);
    //   const data = await wolList(filterParams);
    //   if (
    //     data &&
    //     (data.status.code === 0 ||
    //       data.status.code === 200 ||
    //       data.status.code === 201) &&
    //     data.content
    //   ) {
    //     setIsApi1Failed(false);
    //     setWolDataExists(true);
    //     setWolTableData(data.content);
    //     setIsApi(false);
    //   } else {
    //     setIsApi(false);
    //     setIsApi1Failed(true);
    //     changeApiStatusCodeFunc(data.status);
    //   }
    // };

    // useEffect(() => {
    //   if (wolStatsData) {
    //     const filterParams = {
    //       statId: selectedStatId,
    //       pageLength: userSession.pageLength,
    //       pageNo: 1,
    //     };
    //     if (showLimitedDriver === 0) {
    //       filterParams["isShowAllDrivers"] = 1;
    //     } else {
    //       filterParams["isShowAllDrivers"] = 0;
    //     }
    //     setApiFilterParams({ ...filterParams });
    //     // getWolList(filterParams);
    //   }
    // }, [wolStatsData, selectedStatId]);

    const handleTileClickFunc = (data) => {
        if (data.typeOfScore === "walloflegend") {
            setWolTableData(null);
            setSelectedStatId(data.selectedStatId);
            setShowLimitedDriver(0);
        }
    };

    // const showLimitedDriverFunc = (showLimitedDriverBool) => {
    //   return false;
    //   if (wolStatsData) {
    //     const filterParams = {
    //       pageLength: userSession.pageLength,
    //       pageNo: 1,
    //     };
    //     if (showLimitedDriverBool === 0) {
    //       filterParams["isShowAllDrivers"] = 1;
    //       filterParams["statId"] = selectedStatId;
    //     } else {
    //       filterParams["statId"] = 0;
    //     }
    //     setShowLimitedDriver(showLimitedDriverBool);
    //     // @todo: need to remove
    //     // setApiFilterParams({...filterParams})
    //     // getWolList(filterParams);
    //   }
    // };

    return (
        <>
            <CustomBox key="walloflegendcontainer" mb={8}>
                <ScoreCardList
                    isApiFailed={isApiFailed}
                    key="walloflegend"
                    data={wolStatsData}
                    typeOfScore="walloflegend"
                    handleTileClick={handleTileClickFunc}
                    selectedStatId={selectedStatId}
                    showLimitedDriver={showLimitedDriver}
                    isGroupScoped={
                        getRBAC_WOL_Show_Limited &&
                            getRBAC_WOL_Show_Limited.isAccessible === EntityAccess.ALLOWED
                            ? false
                            : true
                    }
                />
            </CustomBox>
            {/* <div style={{ overflow: "auto" }}> */}
            <PraisoTableWrapper
                statData={wolStatsData} 
                // getTableSettingAPI={`user-table-component-mapping?tcCode=${TableComponentCodes.WALL_OF_LEGEND}`}
                getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.WALL_OF_LEGEND}`}
                tableSettingView={TableComponentCodes.WALL_OF_LEGEND}
                getTableDataAPI={`${APIURL.WOL_USER_LIST_API}${showLimitedDriver === 1 ? 0 : selectedStatId
                    }`}
                getTableDataApiParam={{
                    isShowAllDrivers: showLimitedDriver === 1 ? 0 : 1,
                }}
                updateCurrentLimitedRow={showLimitedDriver}
                showMoreOrLessComp={
                    getRBAC_WOL_Show_Limited &&
                        getRBAC_WOL_Show_Limited.isAccessible === EntityAccess.ALLOWED ? (
                        <ShowMoreOrLess
                            updateShowMoreStatus={(currentLabel) =>
                                setShowLimitedDriver(currentLabel)
                            }
                            setShowMoreStatus={showLimitedDriver}
                        />
                    ) : null
                }
                {...props}
            />
            {/* </div> */}
            {/* <WallofLegendsRanking
        isApiFailed={isApi1Failed}
        data={wolTableData}
        selectedStatId={selectedStatId}
        wolDataExists={wolDataExists}
        isApi={isApi}
        showLimitedDriver={showLimitedDriver}
        showLimitedDriverSet={(showLimitedDriverBool) =>
          showLimitedDriverFunc(showLimitedDriverBool)
        }
      /> */}
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
